module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dateFrom":"Choose date from","dateTo":"Choose date until","departureDate":"Date of departure","places":"Places","choosePlace":"Choose place","failedToFetch":"Failed to search for trips"},"no":{"dateFrom":"Velg dato fra","dateTo":"Velg dato til","departureDate":"Avgangsdato","places":"Steder","choosePlace":"Velg sted","failedToFetch":"Kunne ikke søke etter turer"}}')
  delete Component.options._Ctor
}
